import { render, staticRenderFns } from "./FreightTableVehicleSelect.vue?vue&type=template&id=4b8ba5c7&scoped=true"
import script from "./FreightTableVehicleSelect.vue?vue&type=script&lang=js"
export * from "./FreightTableVehicleSelect.vue?vue&type=script&lang=js"
import style0 from "./FreightTableVehicleSelect.vue?vue&type=style&index=0&id=4b8ba5c7&prod&scoped=true&lang=less"
import style1 from "./FreightTableVehicleSelect.vue?vue&type=style&index=1&id=4b8ba5c7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8ba5c7",
  null
  
)

export default component.exports